import { createState } from '../../lib/create-state';

export type FireBallStatus = 'active' | 'pending' | 'snuffed';

export const DEFAULT_FIRE_BALL_STATUS: FireBallStatus = 'active';

export const [fireBallStatus, resetFireBallStatus] =
    createState<FireBallStatus>(DEFAULT_FIRE_BALL_STATUS);
